export default function loadScript(src, cache = true) {
  return new Promise((resolve, reject) => {
    if (!cache) {
      const time = new Date().getTime()
      src = `${src}${src.includes(`?`) ? `&` : `?`}cachebust${time}=${time}`
    }

    const script = document.createElement(`script`)
    script.addEventListener(`load`, resolve)
    script.addEventListener(`error`, () =>
      reject(new Error(`Error loading script`))
    )
    script.addEventListener(`abort`, () =>
      reject(new Error(`Script loading aborted`))
    )
    script.async = true
    script.src = src
    document.head.appendChild(script)
  })
}
